/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Measure_Latency_Weighted_P50Inputs */

const en_measure_latency_weighted_p50 = /** @type {(inputs: Measure_Latency_Weighted_P50Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weighted p50 estimate`)
};

const zh_hans1_measure_latency_weighted_p50 = /** @type {(inputs: Measure_Latency_Weighted_P50Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`p50 加权估算`)
};

const pt_br2_measure_latency_weighted_p50 = /** @type {(inputs: Measure_Latency_Weighted_P50Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimativa ponderada de p50`)
};

const es_measure_latency_weighted_p50 = /** @type {(inputs: Measure_Latency_Weighted_P50Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimación ponderada de p50`)
};

const fr_measure_latency_weighted_p50 = /** @type {(inputs: Measure_Latency_Weighted_P50Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimation p50 pondérée`)
};

const de_measure_latency_weighted_p50 = /** @type {(inputs: Measure_Latency_Weighted_P50Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewichtete p50-Schätzung`)
};

const ru_measure_latency_weighted_p50 = /** @type {(inputs: Measure_Latency_Weighted_P50Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Взвешенная оценка p50`)
};

const it_measure_latency_weighted_p50 = /** @type {(inputs: Measure_Latency_Weighted_P50Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stima p50 ponderata`)
};

/**
* | output |
* | --- |
* | "Weighted p50 estimate" |
*
* @param {Measure_Latency_Weighted_P50Inputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_latency_weighted_p50 = /** @type {((inputs?: Measure_Latency_Weighted_P50Inputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Latency_Weighted_P50Inputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_latency_weighted_p50(inputs)
	if (locale === "pt-BR") return pt_br2_measure_latency_weighted_p50(inputs)
	if (locale === "es") return es_measure_latency_weighted_p50(inputs)
	if (locale === "fr") return fr_measure_latency_weighted_p50(inputs)
	if (locale === "de") return de_measure_latency_weighted_p50(inputs)
	if (locale === "ru") return ru_measure_latency_weighted_p50(inputs)
	if (locale === "it") return it_measure_latency_weighted_p50(inputs)
	return en_measure_latency_weighted_p50(inputs)
});